// @ts-nocheck

class QuickOrderList extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    // Handle focus on quantity input fields
    document.addEventListener(
      'focus',
      this.handleQuantityFocus.bind(this),
      true,
    );
  }

  handleQuantityFocus(event) {
    if (event.target.classList.contains('quantity-add')) {
      const input = event.target;
      input.classList.add('hasText');
      input.removeEventListener('keypress', this.handleKeypress.bind(this));
      input.addEventListener('keypress', this.handleKeypress.bind(this));

      // Highlight the current row and enable the button
      const row = input.closest('quick-add-table-row');
      document
        .querySelectorAll('quick-add-table-row')
        .forEach((tr) => tr.classList.remove('_highlight'));
      row.classList.add('_highlight');
      row.querySelector('.button[data-add-to-cart]').disabled = false;
    }
  }

  handleKeypress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const row = event.target.closest('quick-add-table-row');
      row.querySelector('button').click();
    }
  }

  addToCartAction(e) {
    e.preventDefault();
    const addToCartButton = e.target;
    const variantInputs = addToCartButton
      .closest('quick-add-table-row')
      .querySelectorAll('quick-quantity-input input');

    const availableVariants = this.getAvailableVariants(variantInputs);

    if (availableVariants.length) {
      const atcLoader = addToCartButton?.querySelector('#loader.leo-hidden');
      atcLoader?.classList.add('leo-block');
      atcLoader?.classList.remove('leo-hidden');
      this.addVariantsToCart(availableVariants, addToCartButton)
        .then((response) => this.updateCartUI(response))
        .catch((error) => new ShowToast('error', error))
        .finally(() => this.clearInputFields(variantInputs));
    }
  }

  addAllToCartAction(e) {
    e.preventDefault();
    const button = e.target;

    // Find all rows in the table
    const rows = document.querySelectorAll('quick-add-table-row');
    const allVariantInputs = Array.from(rows).flatMap((row) =>
      Array.from(row.querySelectorAll('quick-quantity-input input')),
    );

    const availableVariants = this.getAvailableVariants(allVariantInputs);

    if (availableVariants.length) {
      const atcLoader = button.querySelector('#loader.leo-hidden');

      atcLoader.classList.add('leo-block');
      atcLoader.classList.remove('leo-hidden');
      this.addVariantsToCart(availableVariants, button)
        .then((response) => this.updateCartUI(response))
        .catch((error) => new ShowToast('error', error))
        .finally(() => this.clearInputFields(allVariantInputs));
    } else {
      new ShowToast('error', 'No items input provided to add to cart');
    }
  }

  getAvailableVariants(variantInputs) {
    return Array.from(variantInputs)
      .map((input) => {
        const qty = parseInt(input.value, 10);
        const availableQty = parseInt(input.max, 10); // Assuming max is the available quantity

        const variantColor = input.dataset.variantColor;
        const variantSize = input.dataset.variantSize;

        if (qty > availableQty) {
          if (availableQty > 0) {
            new ShowToast(
              'warning',
              `For variant <span class="leo-font-bold leo-ml-0">${ variantColor } / ${ variantSize }</span>, the quantity exceeds available stock. Only ${ availableQty } will be added.`,
            );
          } else {
            new ShowToast(
              'error',
              `<span class="leo-font-bold leo-ml-0">${ variantColor } / ${ variantSize }</span> is Out of stock. No items will be added.`,
            );
          }
          return {id: input.dataset.variantId, quantity: availableQty}; // Pass only available quantity
        }

        return qty > 0 ? {id: input.dataset.variantId, quantity: qty} : null;
      })
      .filter((variant) => variant !== null);
  }

  async addVariantsToCart(variants, button) {
    // Prepare the formData object with all variants
    const formData = {
      items: variants.map((variant) => ({
        id: variant.id,
        quantity: variant.quantity,
      })),
      sections: 'cart-icon-bubble,cart-drawer',
    };

    // Make a single fetch call with all variants
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      // Show a success message
      if (data?.items && data?.items?.length > 0) {
        new ShowToast('success', 'Added to cart!');
      }
      return data;
    } catch (error) {
      console.error(error);
      if (error.description) {
        new ShowToast('error', error.description);
      } else {
        new ShowToast(
          'error',
          'An error occurred while adding items to the cart',
        );
      }
      return error;
    }
  }

  clearInputFields(inputs) {
    inputs.forEach((input) => {
      input.value = ''; // Clear the value of each input element
    });
  }

  updateCartUI(response) {
    // Assuming response.sections contains the HTML for each section
    if (response.sections) {
      const sectionSelectors = {
        'cart-drawer': '#cart-drawer-aside', // Update with the correct selector for the cart drawer
        'cart-icon-bubble': '#cart-icon-bubble', // Update with the correct selector for the cart icon bubble
      };

      for (const [sectionId, html] of Object.entries(response.sections)) {
        const parser = new DOMParser();
        const parsedDocument = parser.parseFromString(html, 'text/html');
        const newContent = parsedDocument.body.firstChild;

        if (newContent && sectionSelectors[sectionId]) {
          const targetElement = document.querySelector(
            sectionSelectors[sectionId],
          );

          if (targetElement) {
            targetElement.replaceWith(newContent);
          }
        }
      }

      document
        .querySelectorAll('#loader.block')
        .forEach((loader) => (loader.className = 'leo-center leo-hidden'));

      // Open the cart drawer
      if (response.items && response.items.length > 0) {
        // setTimeout(() => {
        //   this.openCartDrawer();
        // }, 2000);
      }
    }
  }

  openCartDrawer() {
    // Example: Your method for opening the cart might look something like this, depending on your CSS and HTML structure.
    document.querySelector('cart-drawer').classList.add('animate', 'active');
  }

  closeCartDrawer() {
    document.querySelector('cart-drawer').classList.remove('active', 'animate');
  }
}

customElements.define('quick-order-list', QuickOrderList);

class AddVariantsToCart extends QuickOrderList {
  constructor () {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('click', this.addToCartAction.bind(this));
  }
}

customElements.define('add-variants-to-cart', AddVariantsToCart);

class AddAllVariantsToCart extends QuickOrderList {
  constructor () {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('click', this.addAllToCartAction.bind(this));
  }
}

customElements.define('add-all-variants-to-cart', AddAllVariantsToCart);

function formatPriceWithSymbolAndCode(value) {
  const locale = `${ window.Shopify.locale }-${ window.Shopify.country }`;
  const currency = window.Shopify.currency?.active;
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
  });

  const symbolFormatted = formatter.format(value); // "$0.00"
  return `${ symbolFormatted } ${ currency }`; // "$0.00 USD"
}
class QuickQuantityInput extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback() {
    this.render();
    this.bindEvents();
  }

  render() {
    this.renderInput();
    this.renderInputControls();
    this.renderStock();
  }

  renderInput() {
    this.inputWrapper = document.createElement('div');
    this.inputWrapper.className =
      'leo-w-full leo-h-full leo-px-2 leo-py-2.5 leo-flex leo-flex-row leo-justify-between leo-items-center leo-rounded-md leo-outline leo-outline-1 leo-outline-brand-grey-200';
    this.input = document.createElement('input');

    // Copy all attributes to input
    for (const attr of this.attributes) {
      this.input.setAttribute(attr.name, attr.value);
    }

    this.input.type = this.type || 'number';
    this.inputWrapper.appendChild(this.input);
  }

  renderInputControls() {
    this.controls = document.createElement('div');
    this.controls.className =
      'leo-max-w-2 leo-w-full leo-h-full leo-flex leo-flex-col leo-justify-center leo-items-center leo-gap-1';

    this.incrementBtn = document.createElement('button');
    this.incrementBtn.type = 'button';
    this.incrementBtn.innerHTML = `<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 4.99997C0.5 4.99997 3.44593 0.999999 4.5 1C5.55413 1 8.5 5 8.5 5" stroke="#475467" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    this.incrementBtn.className = 'increment-btn';

    this.decrementBtn = document.createElement('button');
    this.decrementBtn.type = 'button';
    this.decrementBtn.innerHTML = `<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.5 1.00003C8.5 1.00003 5.55407 5 4.5 5C3.44587 5 0.5 1 0.5 1" stroke="#475467" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    this.decrementBtn.className = 'decrement-btn';

    this.controls.appendChild(this.incrementBtn);
    this.controls.appendChild(this.decrementBtn);

    this.inputWrapper.appendChild(this.controls);
  }

  renderStock() {
    this.stock = document.createElement('span');
    this.initialStockValue = parseInt(this.getAttribute('data-stock') || '0');
    this.stock.className =
      'stock leo-text-xxs leo-text-brand-grey-400 leo-leading-[100%]';
    this.updateStockDisplay();
    this.appendChild(this.inputWrapper);
    this.appendChild(this.stock);
  }

  updateStockDisplay() {
    const inputValue = parseInt(this.input.value || '0');
    const remainingStock = Math.max(0, this.initialStockValue - inputValue);

    // Update color based on stock level
    if (remainingStock <= 0) {
      this.stock.className =
        'stock leo-text-xs leo-text-brand-error-500 leo-leading-[100%]';
      this.stock.textContent = 'Stock Out';
    } else if (remainingStock <= 100) {
      this.stock.className =
        'stock leo-text-xs leo-text-brand-warning-500 leo-leading-[100%]';
      this.stock.textContent = `${ remainingStock } in stock`;
    } else {
      this.stock.className =
        'stock leo-text-xxs leo-text-brand-grey-400 leo-leading-[100%]';
      this.stock.textContent = `${ remainingStock } in stock`;
    }

    // Always dispatch the event whenever stock display is updated
    this.dispatchCustomEvent();
  }

  dispatchCustomEvent() {
    const event = new CustomEvent('quick-add:quantity-update', {
      detail: {
        value: this.input.value,
        variantId: this.getAttribute('data-variant-id'),
        price: this.getAttribute('data-price'),
      },
      bubbles: true,
    });
    this.dispatchEvent(event);
  }

  bindEvents() {
    this.addEventListener('focus', this.handleFocus.bind(this), true);
    this.addEventListener('blur', this.handleBlur.bind(this), true);
    this.addEventListener('keydown', this.handleKeypress.bind(this), true);
    this.input.addEventListener('input', this.handleInput.bind(this));
    this.incrementBtn.addEventListener('click', this.increment.bind(this));
    this.decrementBtn.addEventListener('click', this.decrement.bind(this));
  }

  handleFocus() {
    this.classList.add('active');
  }

  handleBlur() {
    if (this.input && this.input.value === '') {
      this.classList.remove('active');
    }
  }

  handleKeypress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  handleInput() {
    const value = this.input.value;
    if (isNaN(value)) {
      this.input.value = 0;
    } else if (parseInt(value) < 0) {
      this.input.value = this.getAttribute('min') || 0;
    } else if (parseInt(value) > parseInt(this.getAttribute('max'))) {
      this.input.value = this.getAttribute('max');
    }
    // Update the stock display whenever input changes
    this.updateStockDisplay();
  }

  increment() {
    this.input.value = parseInt(this.input.value || '0') + 1;
    this.handleInput();
  }

  decrement() {
    this.input.value = Math.max(
      parseInt(this.input.value || '0') - 1,
      parseInt(this.getAttribute('min')) || 0,
    );
    this.handleInput();
  }

  get value() {
    return this.input?.value || '';
  }

  set value(val) {
    if (this.input) {
      this.input.value = val;
    }
  }
}

customElements.define('quick-quantity-input', QuickQuantityInput);

class QuickAddTableRow extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener(
      'quick-add:quantity-update',
      this.calculateRowTotal.bind(this),
    );
  }

  calculateRowTotal(e) {
    this.rowTotal = 0; // Reset rowTotal before recalculating
    const quantityInputs = this.querySelectorAll('quick-quantity-input');
    const rowPriceElement = this.querySelector('quick-add-table-row-price');

    if (quantityInputs.length === 0) {
      console.warn('No quantity inputs found in this row.');
      return;
    }

    quantityInputs.forEach((qtyInput) => {
      // Get price from data-price attribute or from the event detail if available
      let price = parseFloat(qtyInput.getAttribute('data-price') || 0);

      let quantity = parseFloat(qtyInput.value || 0);

      // If this was triggered by an event, use event data for the specific input that changed
      if (
        e &&
        e.detail &&
        e.detail.variantId &&
        qtyInput.getAttribute('data-variant-id') === e.detail.variantId
      ) {
        quantity = parseFloat(e.detail.value || 0);
        if (e.detail.price) {
          price = parseFloat(e.detail.price);
        }
      }

      if (isNaN(price) || isNaN(quantity)) {
        console.warn('Invalid price or quantity detected:', {price, quantity});
        return;
      }

      const total = quantity * price;
      this.rowTotal += total;
    });

    rowPriceElement.dataset.rowTotal = this.rowTotal;
  }
}

customElements.define('quick-add-table-row', QuickAddTableRow);

class QuickAddTableRowPrice extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback() {
    this.bindEvents();
    this.renderRowTotal();
  }

  bindEvents() {
    document.addEventListener(
      'quick-add:quantity-update',
      this.renderRowTotal.bind(this),
    );
  }

  renderRowTotal() {
    const price = this.dataset.rowTotal || 0;
    const formatted = formatPriceWithSymbolAndCode(price);

    this.innerHTML = `<span class="leo-text-center leo-justify-start leo-text-brand-grey-900 leo-text-xs leo-font-medium leo-leading-tight">${ formatted }</span>`;
  }
}

customElements.define('quick-add-table-row-price', QuickAddTableRowPrice);

class QuickAddTable extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener(
      'quick-add:quantity-update',
      this.calculateTableTotal.bind(this),
    );
  }

  calculateTableTotal(e) {
    this.tableTotal = 0; // Reset tableTotal before recalculating
    const rowPriceElements = this.querySelectorAll('quick-add-table-row-price');
    const tablePriceElement = this.querySelector('quick-add-table-total-price');

    if (rowPriceElements.length === 0) {
      console.warn('No row level price element found in this table.');
      return;
    }

    rowPriceElements.forEach((rowElement) => {
      // Get price from data-price attribute or from the event detail if available
      let rowTotal = parseFloat(rowElement.getAttribute('data-row-total') || 0);

      this.tableTotal += rowTotal;
    });

    tablePriceElement.dataset.tableTotal = this.tableTotal;
  }
}
customElements.define('quick-add-table', QuickAddTable);

class QuickAddTableTotalPrice extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback() {
    this.bindEvents();
    this.renderTableTotal();
  }

  bindEvents() {
    document.addEventListener(
      'quick-add:quantity-update',
      this.renderTableTotal.bind(this),
    );
  }

  renderTableTotal() {
    const price = this.dataset.tableTotal || 0;
    const formatted = formatPriceWithSymbolAndCode(price);

    this.innerHTML = `<span class="leo-text-center leo-justify-start leo-text-brand-grey-900 leo-text-xs leo-font-medium leo-leading-tight">${ formatted }</span>`;
  }
}
customElements.define('quick-add-table-total-price', QuickAddTableTotalPrice);
